<div class="classic-page-container">
  <form autocomplete="off" [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
    <div class="delimiter-with-content">
      <h1>{{ 'fspro.front.forgotten_password.header.label.title' | translate }}</h1>
    </div>

    <p class="description">
      {{'fspro.front.forgotten_password.form.instruction' | translate}}
    </p>

    <div class="input-wrapper">

      <div class="fspro-control-input-wrapper display-filled-placeholder">
        <mat-form-field>
          <mat-label>{{ 'Email' | translate}} </mat-label>
          <input name="emailField" matInput autocomplete="off" autocapitalize="off" class="input-note" formControlName="emailField">
          <mat-error *ngIf="forgotForm.get('emailField').hasError('email')">
            Please enter a valid email!
          </mat-error>
        </mat-form-field>
        @if (getPasswordLinkFailed) {
          <div class="error-container">
            @if (errorMessage === 'Not confirmed') {
              <span>Your account is not activated. Click <a class="error-link" (click)="sendActivationEmail()">here</a> to receive an email with instructions.</span>
            }
            @if (confirmationMessage) {
              <span>{{ confirmationMessage }}</span>
            }
          </div>
        }
      </div>

    </div>


    <div class="delimiter-with-content submit-wrapper">
      <div>

        <button mat-flat-button type="submit" [disabled]="isSending || forgotForm.invalid">
          <mat-spinner [color]="'primary'" [diameter]="20" *ngIf="isSending"
            style="display: inline-block; margin-right: 5px;">
          </mat-spinner>
          <span> {{ (isSending? 'fspro.front.forgotten_password.form.label.send' : 'fspro.front.forgotten_password.form.label.send' )| translate }}</span>
        </button>

      </div>
    </div>
  </form>
</div>
